module.exports = __webpack_public_path__ + "static/media/all_welds_2.b6707db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/all_welds_2.jpg
// module id = 1878
// module chunks = 0